document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.removeAnimation .animate--slide-in').forEach(element => {
        element.classList.remove('animate--slide-in');
    });

    document.querySelectorAll('.bottomTopGradient').forEach(element => {
        if (element.parentElement) {
            element.parentElement.classList.add('addBottomTopGradient');
        }
    });

    document.querySelectorAll('.topBottomGradient').forEach(element => {
        if (element.parentElement) {
            element.parentElement.classList.add('addTopBottomGradient');
        }
    });

    const headings = document.querySelectorAll("h3.card__heading");
    let maxHeight = 0;

    headings.forEach(heading => {
        const headingHeight = heading.offsetHeight;
        if (headingHeight > maxHeight) {
            maxHeight = headingHeight;
        }
    });

    headings.forEach(heading => {
        heading.style.height = `${maxHeight}px`;
    });

    const section = document.querySelector('.madeFNZ');

    if (section) {
        const imageContainers = section.querySelectorAll('.imageContainer');

        const wrapper = document.createElement('div');
        wrapper.className = 'wrapped-content';

        const heading = section.querySelector('.rich-text__heading');
        const text = section.querySelector('.rich-text__text');
        const buttons = section.querySelector('.rich-text__buttons');

        if (heading) wrapper.appendChild(heading);
        if (text) wrapper.appendChild(text);
        if (buttons) wrapper.appendChild(buttons);

        if (imageContainers.length > 1) {
            const secondImageContainer = imageContainers[1];
            secondImageContainer.parentNode.insertBefore(wrapper, secondImageContainer);
        }
    }

    document.querySelectorAll('.facet-checkbox__text-label').forEach(label => {
        label.textContent = label.textContent.replace('category: ', '');
    });
});
